import React from "react";

import { FIELD_TYPE, tabKeys, TT_PHIEU_VTYT } from "types/enums";
import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";
import { Form, Input, Select } from "antd";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 150,
    align: "left",
    fixed: "left",
    isResizable: true
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    isResizable: true,
    dataIndex: "maNhanVien",
    width: 60,
    align: "left",
    fixed: "left",
  },
  {
    title: "Chức vụ",
    key: "chucVu",
    show: true,
    dataIndex: "chucVu",
    width: 150,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "Năm",
    key: "",
    show: true,
    disabledCheck: true,
    dataIndex: "nam",
    align: "center",
    className: "white",
  },
  {
    title: "Số giờ làm việc chuẩn",
    key: "soGioLamViecChuan",
    show: true,
    dataIndex: "soGioLamViecChuan",
    width: 70,
    align: "center",
    isResizable: true
  },
  {
    title: "Số giờ làm thêm",
    key: "soGioLamThem",
    show: true,
    dataIndex: "soGioLamThem",
    width: 80,
    align: "right",
    isResizable: true
  },
  {
    title: "Công làm thêm quy đổi",
    key: "congLamThemQuyDoi",
    show: true,
    dataIndex: "congLamThemQuyDoi",
    width: 80,
    align: "right",
    isResizable: true
  },
  {
    title: "Số giờ làm thêm tính lương",
    key: "soGioLamThemTinhLuong",
    show: true,
    dataIndex: "soGioLamThemTinhLuong",
    width: 80,
    align: "right",
    isResizable: true
  },
  {
    title: "Số giờ làm thêm trả lương chủ nhật",
    key: "soGioLamThemTraLuongChuNhat",
    show: true,
    dataIndex: "soGioLamThemTraLuongChuNhat",
    width: 80,
    align: "right",
    isResizable: true
  },
  {
    title: "Số ngày công làm thêm tính lương",
    key: "soNgayCongLamThemTinhLuong",
    show: true,
    dataIndex: "soNgayCongLamThemTinhLuong",
    width: 80,
    align: "right",
    isResizable: true
  },
  {
    title: "Làm thêm tính nghỉ bù",
    key: "lamThemTinhNghiBu",
    show: true,
    dataIndex: "lamThemTinhNghiBu",
    width: 80,
    align: "right",
    isResizable: true
  },
  // {
  //   title: "Số ngày làm thêm lễ tết",
  //   key: "soNgayLamThemLeTet",
  //   show: true,
  //   dataIndex: "soNgayLamThemLeTet",
  //   width: 80,
  //   align: "center",
  // },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "phong",
    disable: false,
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    rules: [{ required: true, message: "Vui lòng chọn tháng" }],
    options: listMonths,
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,
    rules: [{ required: true, message: "Vui lòng chọn năm" }],
    options: listYears,
  },
];

export { allColumns, itemsInputField };
